import { render, staticRenderFns } from "./SetDangerRegion.vue?vue&type=template&id=1aec0deb&scoped=true"
import script from "./SetDangerRegion.vue?vue&type=script&lang=js"
export * from "./SetDangerRegion.vue?vue&type=script&lang=js"
import style0 from "./SetDangerRegion.vue?vue&type=style&index=0&id=1aec0deb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aec0deb",
  null
  
)

export default component.exports